/**
 * Error Alert Component
 * 
 * Displays error messages using Cloudscape Flashbar component
 */

import React from 'react';
import { Alert, Box, Button } from '@cloudscape-design/components';
import { ApiErrorResponse } from '../api/client';

interface ErrorAlertProps {
  error: ApiErrorResponse | Error | string;
  onDismiss?: () => void;
  onRetry?: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, onDismiss, onRetry }) => {
  // Extract error message
  let errorMessage: string;
  let errorDetails: string | undefined;

  if (typeof error === 'string') {
    errorMessage = error;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else {
    errorMessage = error.message || 'An unexpected error occurred';
    errorDetails = import.meta.env.DEV && (error as any).details ? JSON.stringify((error as any).details, null, 2) : undefined;
  }

  return (
    <Alert
      type="error"
      dismissible={!!onDismiss}
      onDismiss={onDismiss}
      header="Error"
      action={onRetry ? <Button onClick={onRetry}>Retry</Button> : undefined}
    >
      <Box variant="p">{errorMessage}</Box>
      {errorDetails && (
        <Box variant="code" padding={{ top: 's' }}>
          <pre>{errorDetails}</pre>
        </Box>
      )}
    </Alert>
  );
};
